import { QuestionnaireBundleComponent } from './common-component/customer/questionnaire-bundle/questionnaire-bundle.component';
import { AccountType } from './models/user.model';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SelectivePreloadingStrategyService } from './service/selective-preloading-strategy.service';
import { AuthGuard } from './auth/auth.guard';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  {
    path: 'providers',
    data: { title: 'providers' },
    loadComponent: () =>
      import('./views/resources/home/home.component').then(
        (m) => m.HomeComponent
      ),
  },
  {
    path: 'login',
    data: { title: 'login' },
    loadComponent: () =>
      import('./views/basic/login/login.component').then(
        (m) => m.LoginComponent
      ),
  },
  {
    path: 'register',
    data: { title: 'register' },
    loadComponent: () =>
      import('./views/basic/register/register.component').then(
        (m) => m.RegisterComponent
      ),
  },
  {
    path: 'reset',
    data: { title: 'reset' },
    loadComponent: () =>
      import('./views/basic/reset/reset.component').then(
        (m) => m.ResetComponent
      ),
  },
  {
    path: 'forgot',
    data: { title: 'forgot' },
    loadComponent: () =>
      import('./views/basic/forgot/forgot.component').then(
        (m) => m.ForgotComponent
      ),
  },
  {
    path: 'user',
    canActivate: [AuthGuard],
    data: { title: 'user', roles: AccountType.Patient, preload: true,home:true },
    loadChildren: () =>
      import('./lazy-route/patient/patient.module').then(
        (mod) => mod.PatientModule
      ),
  },
  {
    path: 'provider',
    data: { title: 'provider', roles: AccountType.Provider, preload: true },
    loadChildren: () =>
      import('./lazy-route/provider/provider.module').then(
        (mod) => mod.ProviderModule
      ),
  },
  {
    path: 'questionnaire',
    data: { title: 'Questionnaire', preload: true },
    loadChildren: () =>
      import('./lazy-route/questionnaire/questionnaire.module').then(
        (mod) => mod.QuestionnaireModule
      ),
  },
  {
    path: 'resources',
    data: { title: 'resources', preload: true },
    loadChildren: () =>
      import('./lazy-route/resources/resources.module').then(
        (mod) => mod.ResourcesModule
      ),
  },
{
    path: 'test-aalon',
    data: { title: 'terms', preload: true },
    loadComponent: () =>
      import('./common-component/customer/questionnaire-bundle-custom/questionnaire-bundle-custom.component').then(
        (m) => m.QuestionnaireBundleCustomComponent
      ),
  },
  {
    path: '404',
    data: { title: '404' },
    loadComponent: () =>
      import('./views/basic/notfound/notfound.component').then(
        (m) => m.NotfoundComponent
      ),
  },
  {
    path: '**',
    redirectTo: '404',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: false,
      preloadingStrategy: SelectivePreloadingStrategyService, //添加配置项实现预加载
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
